import clsx from "clsx";
import { Fragment } from "react";

interface HighlightedTextProps {
  children: string;
  highlightClassname?: string;
}

export default function HighlightedText({
  children,
  highlightClassname,
}: HighlightedTextProps) {
  const parts = children.split(/(<em>.*?<\/em>)/);

  return (
    <Fragment>
      {parts.map((part, index) => {
        const emMatch = part.match(/^<em>(.*?)<\/em>$/);
        if (emMatch) {
          return (
            <span
              key={`part-${index.toString()}`}
              className={clsx(
                "bg-orange-100 text-orange-500",
                highlightClassname,
              )}
            >
              {emMatch[1]}
            </span>
          );
        }
        return part;
      })}
    </Fragment>
  );
}
